var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.333 6.0415H13.333C12.9913 6.0415 12.708 5.75817 12.708 5.4165C12.708 5.07484 12.9913 4.7915 13.333 4.7915H18.333C18.6747 4.7915 18.958 5.07484 18.958 5.4165C18.958 5.75817 18.6747 6.0415 18.333 6.0415Z",
    fill: "#0B0C0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00033 6.0415H1.66699C1.32533 6.0415 1.04199 5.75817 1.04199 5.4165C1.04199 5.07484 1.32533 4.7915 1.66699 4.7915H5.00033C5.34199 4.7915 5.62533 5.07484 5.62533 5.4165C5.62533 5.75817 5.34199 6.0415 5.00033 6.0415Z",
    fill: "#0B0C0E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33366 8.95833C6.38366 8.95833 4.79199 7.36667 4.79199 5.41667C4.79199 3.46667 6.38366 1.875 8.33366 1.875C10.2837 1.875 11.8753 3.46667 11.8753 5.41667C11.8753 7.36667 10.2837 8.95833 8.33366 8.95833ZM8.33366 3.125C7.06699 3.125 6.04199 4.15 6.04199 5.41667C6.04199 6.68333 7.06699 7.70833 8.33366 7.70833C9.60033 7.70833 10.6253 6.68333 10.6253 5.41667C10.6253 4.15 9.60033 3.125 8.33366 3.125Z",
    fill: "#0B0C0E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 15.2085H15C14.6583 15.2085 14.375 14.9252 14.375 14.5835C14.375 14.2418 14.6583 13.9585 15 13.9585H18.3333C18.675 13.9585 18.9583 14.2418 18.9583 14.5835C18.9583 14.9252 18.675 15.2085 18.3333 15.2085Z",
    fill: "#0B0C0E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 15.2085H1.66699C1.32533 15.2085 1.04199 14.9252 1.04199 14.5835C1.04199 14.2418 1.32533 13.9585 1.66699 13.9585H6.66699C7.00866 13.9585 7.29199 14.2418 7.29199 14.5835C7.29199 14.9252 7.00866 15.2085 6.66699 15.2085Z",
    fill: "#0B0C0E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 18.1248C9.71667 18.1248 8.125 16.5332 8.125 14.5832C8.125 12.6332 9.71667 11.0415 11.6667 11.0415C13.6167 11.0415 15.2083 12.6332 15.2083 14.5832C15.2083 16.5332 13.6167 18.1248 11.6667 18.1248ZM11.6667 12.2915C10.4 12.2915 9.375 13.3165 9.375 14.5832C9.375 15.8498 10.4 16.8748 11.6667 16.8748C12.9333 16.8748 13.9583 15.8498 13.9583 14.5832C13.9583 13.3165 12.9333 12.2915 11.6667 12.2915Z",
    fill: "#0B0C0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingFilter);
export default __webpack_public_path__ + "static/media/settingFilter.307ce41967a2545a36cc1bf185ef5c9d.svg";
export { ForwardRef as ReactComponent };